import type { NextPage } from 'next'
import { joinClassnames } from 'helpers/classNames'
import styles from 'styles/Video.module.scss'
import IconAwesomeComponent from 'componentsUnits/iconAwesome'
import { MdCancel } from "react-icons/md";

interface Props {
  video: string
  onCloseButton?: any
  fullWidth?: boolean
}
const VideoComponent: NextPage<Props> = (props: Props) => {
  const className = joinClassnames([
    styles.container,
    props.fullWidth && styles.fullWidth_image,

  ])
  return <div className={className}>

    <video src={props.video} className={styles.video} width="320" height="240" controls />

    {props.onCloseButton
      &&
      <div className={styles.on_image_button}>
        <MdCancel size={25} onClick={props.onCloseButton} />

        {/* <IconAwesomeComponent size="xSmall" type="4" icon={"xmark"} onClick={props.onCloseButton} /> */}
      </div>
    }

  </div>
}

export default VideoComponent
